export const activeDialog = (state) => state.dialogs.activeDialog;
